/**
 * Commonly used icon colors.
 * @enum {string}
 */
var Color;
(function (Color) {
  Color["BLUE"] = "blue";
  Color["DEFAULT"] = "";
  Color["GRAY"] = "gray";
  Color["GREEN"] = "green";
  Color["MAGENTA"] = "magenta";
  Color["RED"] = "red";
  Color["WHITE"] = "white";
})(Color || (Color = {}));
/**
 * @enum {number}
 */
var Size;
(function (Size) {
  Size[Size["Size12"] = 12] = "Size12";
  Size[Size["Size14"] = 14] = "Size14";
  Size[Size["Size16"] = 16] = "Size16";
  Size[Size["Size18"] = 18] = "Size18";
  Size[Size["Size20"] = 20] = "Size20";
  Size[Size["Size24"] = 24] = "Size24";
  Size[Size["Size32"] = 32] = "Size32";
  Size[Size["Size40"] = 40] = "Size40";
  Size[Size["Size48"] = 48] = "Size48";
  Size[Size["Size64"] = 64] = "Size64";
  Size[Size["Size96"] = 96] = "Size96";
  Size[Size["Size128"] = 128] = "Size128";
})(Size || (Size = {}));

export { Color, Size };
